module.exports = __webpack_public_path__ + "img/IOTX.91d216e3.svg";